// @flow
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from "@material-ui/core/Typography";
import useNow from '../../hooks/useNow';
import UiTime from '../ui/Time';

const utcTimeConfig = {
    hoursFnName: 'getUTCHours',
    minutesFnName: 'getUTCMinutes',
    secondsFnName: 'getUTCSeconds'
};

const useStyles = makeStyles(theme => ({
    timeLoc: {
        marginRight: theme.spacing(2),
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap'
    },
    timeUtc: {
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap'
    }
}));

function Time() {
    const classes = useStyles();
    const now = useNow();

    const date = new Date(now);

    return (
        <Typography component="span" variant="h6">
            <span className={classes.timeLoc}>
                <UiTime date={date} /> LOC
            </span>
            <span className={classes.timeUtc}>
                <UiTime date={date} config={utcTimeConfig} /> UTC
            </span>
        </Typography>
    );
}

export default Time;